module.exports = __webpack_public_path__ + "img/evalViewCandidateIllustration.19daf627.svg";